import React, { useEffect, useState, useContext } from 'react'
import { message } from 'antd'
import DiscountDrawer from './discountDrawer'
import Utils from '../../../../utils/Utils'
import DiscountTable from './discountTable'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import Discounts from './discountSrc'
import { Context } from '../../../../context'

function DiscountTab(props) {
  const [{ auth }] = useContext(Context)
  const [dataSource, setDataSource] = useState([])
  const [editDataDrawer, setEditDataDrawer] = useState(null)
  const [nextPage, setNextPage] = useState('')
  const [loading, setLoading] = useState(true)
  const [visible, setVisible] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [existMoreInfo, setExistMoreInfo] = useState(false)

  useEffect(() => {
    if (props.keyTab === '3') {
      loadData()
    }
    // eslint-disable-next-line
  }, [props.keyTab])

  const loadData = () => {
    setVisible(false)
    setLoading(true)
    Discounts.getDiscounts('', 5, true, 'desc').then(response => {      
      setDataSource(getDiscountsData(response))
      setNextPage(response.data.next_page_url)
      setExistMoreInfo(response.data.next_page_url !== null)
      setLoading(false)
    })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información')
      })
  }

  const getDiscountsData = dataSrc => {
    if (dataSrc !== 'Too Many Attempts.') {
      let _dataSrc = dataSrc?.data?.data || []

      return _dataSrc.map((d, i) => ({
        key: i,
        id: d.id,
        discount_level: d.discount_level,
        company_name: d.company?.name ? d.company?.name : 'Señor tendero',
        company_id: d.company_id,
      }))
    } else {
      message.error('Se excedió el limte de peticiones, espera y recarga la aplicación')
    }
  }

  const searchText = value => {
    setLoading(true)
    const excludeChars = Utils.excludedCharsContent(value)
    Discounts.getDiscounts(value, 5, excludeChars).then(response => {
      setDataSource(getDiscountsData(response))
      setNextPage(response.data.next_page_url)
      setExistMoreInfo(response.data.next_page_url !== null)
      setLoading(false)
    })
  }

  const EditRow = data => {
    setEditDataDrawer(data)
    setEditMode(true)
    setVisible(true)
  }

  const DeleteRow = data => {
    setLoading(true)
    setVisible(false)
    Discounts
      .removeDiscounts(data.id)
      .then(res => {
        if (res.errors && Object.keys(res.errors)?.length > 0) {
          checkErrors(res)
          setLoading(false)
        } else {
          message.success(`${res.discount_level} se ha elminado.`)
          loadData()
        }
      })
      .catch(e => {
        console.log(e)
        message.error('Error al eliminar elemento.')
      })
  }

  const handlerShowDrawer = () => {
    setVisible(true)
    setEditMode(false)
  }

  const moreInfo = () => {
    if (existMoreInfo) {
      setLoading(true)
      Utils.getNextPage(nextPage)
        .then(response => {
          setDataSource(dataSource.concat(getDiscountsData(response)))
          setNextPage(response.data.next_page_url)
          setExistMoreInfo(response.data.next_page_url !== null)
          setLoading(false)
        })
        .catch(err => {
          console.log(err)
          message.error('No se ha podido cargar la información')
        })
    }
  }

  const onClose = () => {
    setVisible(false)
  }

  const onSaveButton = (method, data, id) => {    
    switch (method) {
      case true:
        Discounts
          .editDiscounts(id, data)
          .then(res => {
            if (res.errors && Object.keys(res.errors)?.length > 0) {
              checkErrors(res)
            } else {
              message.success('Informacion actualizada.')
              setVisible(false)
              loadData()
            }
          })
          .catch(e => {
            console.log(e)
            message.error('Error al actualizar la información.')
          })
        break
      case false:
        Discounts
          .newDiscounts(data)
          .then(res => {
            if (res.errors && Object.keys(res.errors)?.length > 0) {
              checkErrors(res)
            } else {
              message.success('Informacion creada.')
              setVisible(false)
              loadData()
            }
          })
          .catch(e => {
            console.log(e)
            message.error('Error al crear la información.')
          })
        break
      default:
        break
    }
  }

  const checkErrors = res => {
    Object.keys(res.errors).map(key => {
      if (key === 'code') {
        return message.error(res.errors[key][0].replace('code', 'SKU'))
      } else {
        return message.error(res.errors[key])
      }
    })
  }

  return (
    <>
      <DiscountTable
        dataSource={dataSource}
        handlerTextSearch={searchText}
        handlerEditRow={EditRow}
        handlerDeleteRow={DeleteRow}
        handlerShowDrawer={handlerShowDrawer}
        loading={loading}
        descuento={true}
        create={auth.company?.allow_add_products}
        createPermissions={78}
        editPermissions={79}
        deletePermissions={80}
      />
      <LoadMoreButton handlerButton={moreInfo} moreInfo={existMoreInfo} />
      <DiscountDrawer auth={auth} closable={onClose} visible={visible} edit={editMode} editData={editDataDrawer} cancelButton={onClose} saveButton={onSaveButton} />
    </>
  )
}

export default DiscountTab
